module.exports = __webpack_public_path__ + "static/media/a14.c6010bd7.jpg";